module.exports = __webpack_public_path__ + "static/revoice_logo.6c382c67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/revoice_logo.svg
// module id = 342
// module chunks = 114276838955818